import React, { ReactElement } from 'react';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';

import { InputBaseComponentProps, TextField, type TextFieldProps } from "@material-ui/core";

interface IProps {
  input: WrappedFieldInputProps;
  meta: WrappedFieldMetaProps;
  staticValue: string;
  label: string;
  readOnly?: boolean;
  type: string;
  endAdornment: any;
  disabled?: boolean;
  errorAsHelperText?: boolean;
  helperText?: React.ReactNode;
  required?: boolean;
  inputProps?: InputBaseComponentProps;
  handleOnBlur?: (value: string) => string;
  onValueChange?: (value: string, name: string) => void;
  InputProps?: TextFieldProps['InputProps'];
}

export const TextFieldComp: React.FC<IProps> = ({
  input,
  label,
  type,
  staticValue,
  readOnly,
  endAdornment,
  meta: { touched, error },
  disabled,
  errorAsHelperText,
  helperText,
  required,
  InputProps,
  inputProps,
  handleOnBlur,
  onValueChange
}) => {
  const isError = touched && !!error;
  let l: ReactElement = <>{label}</>;

  if (isError) {
    if (!errorAsHelperText) l = error;
  } else if (required) {
    l = (
      <>
        {label}
        <sup style={{ color: '#f45858', fontSize: 13 }}>*</sup>
      </>
    );
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    input.onChange(e);
    if (onValueChange) {
      onValueChange(e.target.value, input.name);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    input.onBlur(e);

    let value = e.target.value;
    if (handleOnBlur) {
      const normalized = String(handleOnBlur(value));
      if (normalized !== value) {
        input.onChange(normalized);
        if (onValueChange) {
          onValueChange(normalized, input.name);
        }
      }
    }
  };

  return (
    <TextField
      fullWidth
      label={l}
      error={isError}
      type={type}
      helperText={errorAsHelperText && isError ? error : helperText}
      {...input}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={!!staticValue || disabled}
      inputProps={inputProps}
      InputProps={{
        ...InputProps,
        readOnly: !!readOnly,
        endAdornment,
      }}
    />
  );
};

export default TextFieldComp;